import React from 'react';
import { useGetImportListQuery } from 'src/redux/services/imports';
import ButtonComponent from 'src/components/ButtonComponent';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';
import { Upload } from '@mui/icons-material';
import InsightsModal from 'src/pages/InsightsPage/InsightsModal';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import InsightsTableWrapper from 'src/pages/InsightsPage/InsightsTableWrapper';

const Insights: React.FC = () => {
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [validatingFile, setValidatingFile] = React.useState<boolean>(true);
  const [showSpinner, setShowSpinner] = React.useState<boolean>(false);

  const { data: importData, isLoading: isLoadingImportData, isError: isErrorImportData } = useGetImportListQuery('', { pollingInterval: 3000 });

  return (
    <>
      {isLoadingImportData && <LoadingScreen logo />}
      {!importData && isErrorImportData && <FailureScreen>An error occurred while fetching import data, please retry.</FailureScreen>}
      {importData && (
        <DashboardPageLayout
          title="Insights"
          aside={
            <ButtonComponent
              buttontype="mainaction"
              text="Upload"
              startIcon={<Upload />}
              disabled={showSpinner}
              onClick={() => {
                setOpenModal(true);
                setValidatingFile(true);
              }}
            />
          }
        >
          <InsightsModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            setShowSpinner={setShowSpinner}
            validatingFile={validatingFile}
            setValidatingFile={setValidatingFile}
          />
          <InsightsTableWrapper showSpinner={showSpinner} />
        </DashboardPageLayout>
      )}
    </>
  );
};

export default Insights;
